import { Box } from '@sequencehq/core-components'
import { PreviewContainer } from '../components'

export const EmailPreview = () => {
  return (
    <PreviewContainer>
      <Box width="576px">Email Preview</Box>
    </PreviewContainer>
  )
}
